var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "third_party_modal",
      "no-close-on-backdrop": "",
      "title": _vm.title,
      "static": true,
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetTab
    }
  }, [_c('div', {
    staticClass: "example-modal-content modal-custom-css"
  }, [_vm.errors ? _c('ul', {
    staticClass: "errors",
    staticStyle: {
      "margin-left": "10%",
      "margin-top": "2%",
      "color": "red"
    }
  }, _vm._l(_vm.errors, function (error, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(error[0]))]);
  }), 0) : _vm._e(), !_vm.submissionComplete ? _c('form-wizard', {
    ref: "wizard",
    attrs: {
      "start-index": 0,
      "color": "#70C95A",
      "stepSize": "sm",
      "finishButtonText": "Submit",
      "hideButtons": _vm.currentTab === 0 && !_vm.selectedPlatform
    },
    on: {
      "on-change": _vm.tabChanged,
      "on-complete": _vm.submitMigrationForm
    },
    scopedSlots: _vm._u([{
      key: "step",
      fn: function (props) {
        return _c('wizard-step', {
          attrs: {
            "tab": props.tab,
            "custom-buttons-right": "ju",
            "transition": props.transition,
            "index": props.index
          }
        });
      }
    }], null, false, 80168417)
  }, _vm._l(_vm.formSteps, function (step, index) {
    return _c('tab-content', {
      key: index,
      attrs: {
        "title": step.name,
        "icon": "fa fa-check",
        "before-change": function () {
          return _vm.validateStep(step.name);
        }
      }
    }, [index === 0 ? _c('step-one', {
      ref: step.name,
      refInFor: true,
      on: {
        "selected-platform": _vm.changeTheTab,
        "on-validate": _vm.mergePartialModels
      }
    }) : index === 1 ? _c('step-two', {
      ref: step.name,
      refInFor: true,
      on: {
        "on-validate": _vm.mergePartialModels
      }
    }) : index === 2 ? _c('step-three', {
      ref: step.name,
      refInFor: true,
      on: {
        "on-validate": _vm.mergePartialModels
      }
    }) : _vm._e()], 1);
  }), 1) : _c('div', {
    staticClass: "d-flex justify-content-center align-items-center msgSent"
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/steps-form-logos/sendMsg.png"
    }
  }), _c('div', {
    staticClass: "titleSuccess"
  }, [_vm._v("Your Request has been submitted successfully !")]), _c('p', [_vm._v("We will get back to you soon within 7 business days.")]), _c('button', {
    staticClass: "wizard-btn",
    staticStyle: {
      "cursor": "pointer",
      "background-color": "rgb(112, 201, 90)",
      "border-color": "rgb(112, 201, 90)",
      "color": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Done ")])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }